import { Button, Typography, IconButton } from '@mui/material';
import { StyledHeader } from 'shared/ui/Header/Styledheader';

import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { useAppSelector, useAppDispatch } from 'app/store';
import AddIcon from '@mui/icons-material/Add';
import { setDrawerOpen, setDrawerAction } from 'features/ui/model/uiSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';

export const Header = () => {
  const { title, actionBtn, actionBtnTitle } = useAppSelector((state) => state.ui);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation().pathname;

  const handleLogOut = () => {
    localStorage.setItem('access_token', '');
    localStorage.setItem('refresh_token', '');
    window.location.href = '/auth';
  };

  return (
    <StyledHeader>
      <div className="title">
        <Typography
          variant="h5"
          sx={{ fontWeight: '600' }}
        >
          {title ?? '---'}
        </Typography>
      </div>
      <div className="actions">
        {location === '/shop-dots' || location === '/shop-dots/' ? (
          <Button
            sx={{
              textTransform: 'none',
              marginRight: '30px',
              '.MuiSvgIcon-root': { color: '#fff !important' },
            }}
            variant="contained"
            onClick={() => navigate('/shop-dots/update-users')}
          >
            Обновить пользователей B2B
          </Button>
        ) : null}
        {actionBtn ? (
          <Button
            sx={{
              textTransform: 'none',
              marginRight: '30px',
              '.MuiSvgIcon-root': { color: '#fff !important' },
            }}
            variant="contained"
            startIcon={actionBtn === 'create' || actionBtn === 'createSku' ? <AddIcon /> : null}
            onClick={() => {
              if (location.includes('pages')) {
                navigate('/content/pages/create');
              }
              dispatch(setDrawerAction(actionBtn));
              dispatch(setDrawerOpen(true));
            }}
          >
            {actionBtnTitle}
          </Button>
        ) : (
          false
        )}
        <IconButton>
          <NotificationsNoneOutlinedIcon />
        </IconButton>
        <IconButton onClick={handleLogOut}>
          <LogoutIcon />
        </IconButton>
      </div>
    </StyledHeader>
  );
};
